export default __webpack_public_path__ + "static/media/26.eb7dcbe4.png";